<div class="drive-root" (contextmenu)="$event.preventDefault()" role="application" [attr.aria-label]="translate('drive.viewer_aria_label')">
  <header class="drive-header" [class.filters-open]="mobileFiltersOpen">
    <div class="search-box">
      <mat-icon aria-hidden="true">search</mat-icon>
      <input
        type="text"
        [placeholder]="translate('drive.search_placeholder')"
        [(ngModel)]="search"
        [attr.aria-label]="translate('drive.search_placeholder')" />

      <div class="chips" [attr.aria-label]="translate('drive.filters_aria')">
        <button class="mobile-filter-close" type="button" (click)="mobileFiltersOpen = false" [attr.aria-label]="translate('common.close')">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
        <span class="chip static">{{ translate('drive.my_drive') }}</span>
        <select class="chip" [(ngModel)]="filterType" [attr.aria-label]="translate('drive.filter.type.aria')">
          <option value="all">{{ translate('drive.filter.type.label_all') }}</option>
          <option value="folder">{{ translate('drive.type.folder') }}</option>
          <option value="pdf">{{ translate('drive.type.pdf') }}</option>
          <option value="txt">TXT</option>
          <option value="doc">{{ translate('drive.type.doc') }}</option>
          <option value="sheet">{{ translate('drive.type.sheet') }}</option>
          <option value="slide">{{ translate('drive.type.slide') }}</option>
          <option value="image">{{ translate('drive.type.image') }}</option>
          <option value="video">{{ translate('drive.type.video') }}</option>
          <option value="zip">{{ translate('drive.type.zip') }}</option>
          <option value="other">{{ translate('drive.type.other') }}</option>
        </select>
        <select class="chip" [(ngModel)]="filterOwner" [attr.aria-label]="translate('drive.filter.owner.aria')">
          <option value="all">{{ translate('drive.filter.owner.label_all') }}</option>
          <option value="you">{{ translate('drive.owner.you') }}</option>
          <option value="external">{{ translate('drive.owner.external') }}</option>
          <option value="any">{{ translate('drive.owner.any') }}</option>
        </select>
      </div>
    </div>

    <div class="header-actions">
      <button class="btn-ghost mobile-filter-button" type="button" (click)="mobileFiltersOpen = !mobileFiltersOpen" [attr.aria-expanded]="mobileFiltersOpen" [attr.aria-label]="translate('drive.filters_aria')">
        <mat-icon aria-hidden="true">tune</mat-icon>
        <span>{{ translate('drive.filters') || 'Filtros' }}</span>
      </button>
      <button class="btn-ghost" type="button" [class.active]="detailsOpen" [attr.aria-label]="translate('drive.details')" (click)="toggleDetails()">
        <mat-icon aria-hidden="true">{{ detailsOpen ? 'info' : 'info_outline' }}</mat-icon>
        <span>{{ translate('drive.details') }}</span>
      </button>
      <button class="btn-ghost mobile-tree-button" type="button" (click)="mobileTreeOpen = !mobileTreeOpen" [attr.aria-label]="mobileTreeOpen ? translate('drive.hide_tree') : translate('drive.show_tree')">
        <mat-icon aria-hidden="true">account_tree</mat-icon>
        <span>{{ mobileTreeOpen ? translate('drive.hide_tree') : translate('drive.show_tree') }}</span>
      </button>
    </div>
    <button class="mobile-filter-backdrop" type="button" *ngIf="mobileFiltersOpen" (click)="mobileFiltersOpen = false" [attr.aria-label]="translate('common.close')"></button>
  </header>

  <div class="drive-body" [class.tree-open]="mobileTreeOpen" [class.details-open]="detailsOpen">
    <app-drive-viewer-tree [view]="view"></app-drive-viewer-tree>
    <app-drive-viewer-content [view]="view"></app-drive-viewer-content>

    <aside class="details" *ngIf="detailsOpen" (contextmenu)="onDetailsContextMenu($event)">
      <h3>{{ translate('drive.details') }}</h3>
      <ng-container *ngIf="selectedIds.size && selectedItem as it; else noSel">
        <div class="meta"><b>{{ translate('drive.details.name') }}:</b> {{ displayName(it.name) }}</div>
        <div class="meta"><b>{{ translate('drive.details.type') }}:</b> {{ it.type }}</div>
        <div class="meta"><b>{{ translate('drive.details.location') }}:</b> {{ it.path.join(' / ') }}</div>
        <div class="meta"><b>{{ translate('drive.details.owner') }}:</b> {{ it.owner }}</div>
        <div class="meta"><b>{{ translate('drive.details.size') }}:</b> {{ it.type==='folder' ? '-' : (it.size | fileSize) }}</div>
        <div class="meta"><b>{{ translate('drive.details.created') }}:</b> -</div>
        <div class="meta"><b>{{ translate('drive.details.last_modified') }}:</b> {{ it.modified | date:'medium' }}</div>
        <div class="meta"><b>{{ translate('drive.details.shared') }}:</b> {{ it.shared ? translate('drive.yes') : translate('drive.no') }}</div>
        <div class="meta"><b>{{ translate('drive.details.permissions') }}:</b> {{ translate('drive.permissions.read_only') }}</div>
      </ng-container>
      <ng-template #noSel>
        <p>{{ translate('drive.no_selection_hint') }}</p>
      </ng-template>
    </aside>
  </div>

  <app-drive-viewer-preview [view]="view"></app-drive-viewer-preview>
</div>

<app-drive-viewer-dialogs [view]="view"></app-drive-viewer-dialogs>
